import { Typography } from "@mui/material";


export const TermsOfService = () => {
    return <>
        <Typography variant="h1">Terms of Service</Typography>
        <Typography variant="body1">
            Please read these Terms of Service carefully before using the Brua site (https://brua.io/), operated by Brua IO AS.
            By being a member of and using the Brua site, you agree to everything on this page. If you break these terms, you can’t continue to use Brua.
            Your account is your responsibility, you are responsible for all content that your account publishes on Brua.
            All the spaces that you as a community member create on Brua are MIT licensed, meaning that other people are free to use it as they like. This means that other people can use it for free, they can also fork it, and create new spaces based upon yours.
            It is your responsibility to make sure you have the appropriate copyright to publish the content you publish on Brua. Also, you are not allowed to publish other people’s private information without their authorization. You are not allowed to add links to viruses or any other computer programming routine or engine that might be harmful.
            We can remove you from our platform if we think you are behaving badly.
            Brua also reserves the right to change the Terms of Service without notice.
        </Typography>
    </>
}